module.exports = __webpack_public_path__ + "img/autosense-order-large.354563c7.png";